const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  function formatDate() {
    date = new Date();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ':' + seconds;
    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + strTime;
  }

  return {
    getDiscoveryHistory(metaData) {
      //   /discovery/1.0/user-discovery-status
      //   /discovery/1.0/add
      const url = getUrl('user-discovery-status');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        timeout: 120000
      };

      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode
      };

      //debugger;
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true
      }));

    },
    addDiscoveryHistory(discoItem, metaData) {
      //   /discovery/1.0/history
      //   /discovery/1.0/add
      const url = getUrl('save-user-discovery-status');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        timeout: 120000
      };

      var dateString = formatDate();
      const body = {
        discoveryStatus: discoItem,
        seenDatetime: dateString,
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true
      }));

    }



  };
}

module.exports = apiFactory;
